export const isInternalUser = ({
  user,
  isOpsManager,
}: {
  isOpsManager?: boolean;
  user: { email: string };
}): boolean => {
  return isOpsManager || /.*@thespecsheet\.com/.test(user.email);
};
